export { default as SidePanel } from './side-panel';